import { withOutCustomsFields } from "../components/GlobalContactDetailsForDeal/LeftSide/common/CustomSelectBox";

export const CUSTOM_DOMAIN_ACTIVE = 1;

// List of suspicious keywords or phrases commonly found in scam messages
export const SCAM_KEYWORDS = [
    // Urgency and Fear Tactics
    "urgent", "immediate action required", "act now", "limited time offer", "time-sensitive", "respond immediately", "today only",
    "don't delay", "final notice", "last chance", "warning", "penalty", "act immediately", "don't miss out", "opportunity", "threat detected", "you're at risk",

    // Financial Scams and Fraud
    "lottery", "prize", "winner", "cash prize", "inheritance", "winning", "transfer", "payout", "money", "wire transfer", "debit", "charged", "payment", "transaction",
    "advance fee", "investment", "credit", "deposit", "refund", "overdue payment", "billing issue", "compensation", "grant", "loan approval", "debt relief",
    "bank transfer", "Western Union", "money order", "cashier's check", "Bitcoin", "cryptocurrency", "payment method", "payment details", "PayPal",
    "credit score", "credit report", "interest rate", "mortgage", "settlement", "tax refund", "tax lien", "inheritance claim", "fund release",

    // Phishing and Identity Theft
    "account", "account verification", "unauthorized access", "security alert", "password reset", "confirm account", "verify now",
    "update information", "suspicious activity", "account suspended", "account locked", "unblock", "reactivate account", "login required",
    "social security number", "credit card number", "PIN", "confidential", "sensitive information", "identity verification", "personal details",
    "security question", "KYC", "OTP", "two-factor authentication", "identity proof", "account recovery", "bank statement",

    // Malware and Cybersecurity Threats
    "click here", "visit this link", "fake", "forged", "fraudulent", "phishing", "scam", "malware", "trojan", "virus", "spyware",
    "ransomware", "hack", "data breach", "unauthorized transaction", "compromised account", "network security", "threat detected", "vulnerable",
    "email verification", "download required", "unsecured", "unsafe", "phishing attempt", "infected", "security flaw", "exploit detected",

    // Too Good to Be True Offers
    "free", "amazing deal", "100% guaranteed", "risk-free", "unbelievable", "too good to be true", "act fast", "congratulations", "you're the lucky winner", "exclusive offer", "just pay shipping",
    "limited edition", "one-time offer", "no obligation", "no risk", "special discount", "best price", "hurry up", "free trial", "gift card", "voucher",

    // Fake Support and Impersonation
    "government", "IRS", "customs", "your bank", "your insurance", "tech support", "Microsoft", "Apple Support", "Amazon", "PayPal",
    "customer support", "service representative", "agent", "official", "verified", "bank manager", "financial advisor", "executive",
    "law enforcement", "police", "court order", "legal notice", "official document", "urgent request", "attorney", "solicitor",

    // Contact and Social Engineering Ploys
    "call now", "contact us", "text back", "reply to this message", "get in touch", "speak with an agent",
    "customer service", "hotline", "emergency contact", "helpline", "support desk", "care center", "urgent inquiry", "service center",
    "follow-up", "callback", "response required", "live chat", "immediate support", "direct contact", "feedback required",

    // Fake Job Offers and Employment Scams
    "work from home", "job offer", "hiring", "vacancy", "earn money", "quick cash", "income opportunity", "data entry job",
    "freelance opportunity", "remote work", "high salary", "unlimited earning", "part-time job", "immediate hire", "training fee",

    // Fake Charity and Donation Scams
    "donate", "charity", "help children", "disaster relief", "fundraiser", "nonprofit", "foundation", "support cause",
    "donation request", "help needed", "humanitarian aid", "relief effort", "emergency fund", "crisis support", "volunteer",

    // Miscellaneous Fraudulent Phrases
    "fake check", "false claim", "bogus", "counterfeit", "deceptive", "embezzlement", "extortion", "identity fraud",
    "illicit", "imposter", "manipulate", "mislead", "money laundering", "scam alert", "scheme", "swindle", "victim", "fraudulent transaction",
    "restricted", "deactivated", "safeguard", "authentication failure", "breach of contract", "confidential agreement", "unauthorized withdrawal"
];


export const DEAL_STATUS = {
    WON: 2,
    LOST: 3
};

export const AGENCY_BUSINESS_TYPE = {
    INSURANCE: "INSURANCE",
    REGULAR: "REGULAR"
};
export const PRIVACY_LEVEL = {
    PRIVACY_LEVEL_GLOBAL: 'GLOBAL',
    PRIVACY_LEVEL_PRIVATE: 'PRIVATE'
};

export const TEMPLATE_TYPE = {
    EMAIL: 1,
    SMS: 2,
    VOICE: 3,
    VIDEO_EMAIL: 4,
    MMS: 5,
    POSTCARD: 6,
    GREETING_CARD: 7,
    GIFT: 8,
    LETTER: 9,
    THANKSIO_GREETING_CARD: 10,
    THANKSIO_GIFT: 11,
};

export const SOCKET_NOTIFICATION_ACTIONS = {
    CUSTOM_NOTIFICATION: 'customNotification',
    SMART_FORM_SUBMISSION: 'smartFormSubmission',
    LEAD_OWNER_CHANGE: 'leadOwnerChange',
    BULK_EMAIL_TRACK_NOTIFICATION: 'bulkEmailTrackNotification',
    REDIRECT: 'redirect',
    VIEW_RESULT: 'viewResult',
    FILE_DOWNLOAD: 'fileDownload',
    INSERT: 'insert',
    DELETE: 'delete'
};

export const CAMPAIGN_STATUS = {
    ALL: "ALL",
    RUNNING: "RUNNING",
    PAUSED: "PAUSED",
}

export const PROCESS_MODE_VALUE = {
    ONCE: "once",
    DRIP:'drip'
}

export const GLOBAL_DIALER_TYPES = {
    KEYPAD: 'KEYPAD',
    DEFAULT: 'DEFAULT',
    TRANSFER: 'TRANSFER',
    TEAM_TRANSFER: 'TEAM_TRANSFER',
};

export const STRIPE_BILLING_AGENCY = [238];

export const TRUE_STRING = "TRUE";
export const FALSE_STRING = "FALSE";

export const PERMISSION_MODULES = {
    MANAGE_BILLING: 0,
    MANAGE_USERS: 1,
    MANAGE_GLOBAL_ITEMS: 2,
    EXPORT_CONTACTS: 3,
    EDIT_LEAD_OWNER: 4,
    MANAGE_OTHER_USER_GOALS: 5,
    MANAGE_OTHER_USER_REPORTS: 6,
    MANAGE_OTHER_USER_CALENDAR: 7,
    MANAGE_OTHER_USER_SCHEDULER: 8,
};

export const PERMISSION_LEVELS = {
    READ: 2,
    WRITE: 4,
    DELETE: 8,
};

export const PRIVACY_LEVEL_VALUE = {
    GLOBAL: 0,
    PRIVATE: 1
}

export const TRIGGER_TYPES = {
    ADDED_CAMPAIGN : 1,
    CONTACT_REPLIED : 2,
    CUSTOMER_BOOKED_APPOINTMENT : 3,
    STAGE_CHANGE : 4,
    ADDED_TAG : 5,
    ANNIVERSARY_REMAINDER : 6,
    TASK_REMAINDER : 7,
    APPOINTMENT : 8,
    STALE_OPPORTUNITY : 9,
    DEAL_STATUS_CHANGE : 10,
    FORM_SUBMISSION : 11,
    BIRTHDAY_REMAINDER : 12,
    CALENDLY_APPOINTMENT_BOOKED : 13,
    INCOMING_CALL : 14,
    APPOINTMENT_STATUS_CHANGE : 15,
    MISSED_CALL : 16,
    OUTGOING_CALL : 17,
    SMS_ACCOUNT_SUSPENDED : 19,
    TWILIO_MESSAGE_FILTER : 20,
    TWILIO_DAILY_MESSAGE_CAP : 21,
    CREATE_ACTIVITY : 18
};

export const TRIGGER_STATUS = {
    STATUS_PAUSE :0,
    STATUS_START :1,
    STATUS_DELETE:2,
}

export const ANNIVERSARY_REMAINDER= {
    MONTH_IS: 0,
    DAY_IS: 1,
    BEFORE_NO_OF_DAYS: 2,
    AFTER_NO_OF_DAYS: 3,
    CURRENT_DAY: 4,
    HAS_TAG: 5,
    DOES_NOT_HAS_TAG: 6
}

export const APPOINTMENT= {
    IN_CALENDAR: 0,
    APPOINTMENT_STATUS_IS: 1
}

export const CONTACT_REPLIED = {
    IN_CAMPAIGN : 0,
    REPLY_CHANNEL : 1,
    REPLY_KEYWORD : 2,
    CONTAIN_PHRASE : 3,
    EXACT_MATCH_PHRASE : 4,
};

export const STALE_OPPORTUNITY = {
    DURATION_IN_DAYS : 0,
    IN_ACTIVE_CAMPAIGN : 1,
    HAS_TAG : 2,
    DOES_NOT_HAVE_TAG : 3,
};

export const ACTION_TYPES = {
    ADD_TO_CAMPAIGN : 1,
    REMOVE_FROM_SINGLE_CAMPAIGN : 2,
    REMOVE_FROM_ALL_CAMPAIGN : 3,
    REMOVE_TAG : 4,
    ADD_TAG : 5,
    SEND_EMAIL : 6,
    SEND_SMS : 7,
    ADD_NOTE : 8,
    ADD_TASK:9,
    CHANGE_STAGE:10,
    ADD_COLLABORATOR:11,
    REMOVE_COLLABORATOR:12,
    WEBHOOK_URL:13,
    ADD_LIST : 14,
    REMOVE_LIST : 15,
    REMOVE_ALL_TAG : 16,
    REMOVE_DEAL : 17,
    THIRD_PARTY_INTEGRATION : 18,
    ADD_SOURCE: 19,
    ZAPIER_WEBHOOK : 20,
    TWILIO_PAUSE_ALL_CAMPAIGN : 21,
    TWILIO_PAUSE_ALL_COMMUNICATION : 22,
    TWILIO_EMAIL_USER : 23,
    TWILIO_SMS_USER : 24,
    TWILIO_PAUSE_SPECIFIC_CAMPAIGN : 25,
    SMART_WEBHOOK: 29,
    UPDATE_CONTACT: 30
}

export const SEND_TO = {
    CONTACT : 0,
    ADDRESS : 1
}

export const BIRTHDAY_REMAINDER= {
    MONTH_IS: 0,
    DAY_IS: 1,
    BEFORE_NO_OF_DAYS: 2,
    AFTER_NO_OF_DAYS: 3,
    CURRENT_DAY: 4,
    HAS_TAG: 5,
    DOES_NOT_HAS_TAG: 6
}

export const CONTACT_TAG= {
    TAG_ADDED: 0,
    TAG_REMOVED: 1
}

export const TASK_REMAINDER= {
    BEFORE_NO_OF_DAYS: 0,
    AFTER_NO_OF_DAYS: 1,
}

export const PACKAGE_PAGE_URL = '/user/packages';

export const ACTION_CONTACT_UPDATE_DEFINED_FILTER = [
    {value:'phone',label: 'Phone'}
]

export const ACTION_CONTACT_UPDATE_FILTER_OPTIONS = [
    {value:'contact_next_phone',label: 'contact_next_phone'}
]

export const WITHOUT_CUSTOM_FIELDS = [
        {
          value: 'blue',
          label: 'Personalized',
          color: '#f2f2f2',
          isDisabled: true
        },
        ...withOutCustomsFields,
        {
          value: 'blue',
          label: 'User Personalize Fields',
          color: '#f2f2f2',
          isDisabled: true
        }
    
    ]


export const PERSONAL_TABS = {
  PERSONAL_INFO: "PERSONAL_INFO",
  RELATED_CONTACTS: "RELATED_CONTACTS",
  ADDITIONAL_INFO: "ADDITIONAL_INFO",
};

export const BUSINESS_TABS = {
  BUSINESS_INFO: "BUSINESS_INFO",
  PRIMARY_CONTACT: "PRIMARY_CONTACT",
  ADDITIONAL_INFO: "ADDITIONAL_INFO",
};

export const CONTACT_TYPE = {
  PERSONAL: "PERSONAL",
  COMMERCIAL: "COMMERCIAL",
};